// src/layout/Sidebar.jsx
import { Layout, Menu } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { getMenuItems } from "./menuItems";

const { Sider } = Layout;

const Sidebar = ({ collapsed, setCollapsed, navigate, handleLogout }) => {
  const location = useLocation();

  const selectedKey = useMemo(() => {
    if (location.pathname.startsWith("/dashboard/upload-result")) return "upload";
    if (location.pathname.startsWith("/dashboard/data-entry")) return "data-entry";
    return "home";
  }, [location.pathname]);

  const menuItems = getMenuItems(navigate, handleLogout);

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth={64}
      breakpoint="lg"
      onBreakpoint={(broken) => setCollapsed(broken)}
      className="bg-gradient-to-r from-[#B631B1] to-[#7048D7] hover:from-[#B631B1] hover:to-[#7048D7] sticky top-0 left-0 min-h-[100dvh] z-30"
      width={240}
    >
      <div className="h-16 flex items-center justify-between px-3 text-white text-lg font-semibold tracking-wide">
        {!collapsed && (
          <span className="inline-block rounded-md bg-white/20 px-2 py-1 m-8 whitespace-nowrap overflow-hidden text-ellipsis">
            Xynex AI
          </span>
        )}
        <button
          type="button"
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          onClick={() => setCollapsed(!collapsed)}
          className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-white/20 hover:bg-white/30 transition"
        >
          {collapsed ? (
            <MenuUnfoldOutlined className="text-white text-base" />
          ) : (
            <MenuFoldOutlined className="text-white text-base" />
          )}
        </button>
      </div>

      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        items={menuItems}
        className="bg-gradient-to-r from-[#B631B1] to-[#7048D7] hover:from-[#B631B1] hover:to-[#7048D7] text-base font-medium"
      />
    </Sider>
  );
};

export default Sidebar;